import { restartableTask } from 'ember-concurrency';
import IntlService from 'ember-intl/services/intl';
import Report, { ReportResourceName } from 'volta/models/report';
import StoreService from 'volta/services/store';

import { action, get } from '@ember/object';
import { inject as service } from '@ember/service';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

import { IArgs as IBvSelectArgs } from '../bv-select/index';

interface IArgs extends Omit<IBvSelectArgs, 'onChange'> {
  onChange?: (id: string, model: Report) => void;
  selected?: string;
}

export default class ReportSelect extends Component<IArgs> {
  // Services
  // ~~~~~
  @service store!: StoreService;
  @service intl!: IntlService;

  idKey: keyof Report = 'id';
  propertyKey: keyof Report = 'name';

  @tracked reports: Report[] = [];
  @tracked selected?: Report;

  // Actions
  // ~~~~~

  @action
  onChange(value: Report) {
    const { idKey } = this;
    const idValue = isPresent(value) ? get(value, idKey) : value;
    this.selected = value;
    return this.args.onChange?.(idValue as string, value);
  }

  fetchReports = restartableTask(async () => {
    const reportQuery = {
      page: {
        offset: 0,
        limit: 250
      },
      sort: 'name'
    };
    // @ts-ignore - Array is OK
    this.reports = await this.store.query(ReportResourceName.singular, reportQuery);
    if (this.args.selected) {
      this.selected = this.reports.find((r) => r.id === this.args.selected);
    }
  });
}
